import * as React from 'react'

interface IVideoEmbedProps {
  className?: string
  videoId: string
  title: string
  autoPlay?: boolean
}

export default class VideoEmbed extends React.PureComponent<IVideoEmbedProps> {
  public render() {
    return (
      <iframe
        className={`bg-transparent border-0 ${this.props.className}`}
        src={`https://fast.wistia.net/embed/iframe/${this.props.videoId}?seo=false&videoFoam=false&autoplay=${this.props.autoPlay ? 'true' : 'false'}&silentAutoPlay=false`}
        title={this.props.title}
        allow='autoplay; fullscreen'
        ></iframe>
    )
  }
}
